import type { LayoutSQV2Props as Props } from './types';
import { BuilderChildProps } from '@/types';
import React from 'react';
import { withChildren } from '@builder.io/react';
import { cls } from '@/utils/cls';
import { ALLOWED_CHILD_COMPONENT_NAMES, CONTROLLED_COMPONENT_NAMES } from './constants';
import style from './LayoutSQV2.module.scss';
export function LayoutSQV2({
  extendStyles,
  children
}: Props) {
  const childrenList = React.Children.toArray(children) as React.ReactElement<BuilderChildProps>[];
  const allowedChildren = childrenList.filter(child => {
    const name = child?.props?.block?.component?.name;
    return typeof name === 'string' && ALLOWED_CHILD_COMPONENT_NAMES.includes(name);
  });
  if (childrenList.length === 0 || allowedChildren.length === 0) {
    return <div className={cls(style.root, extendStyles)}>
				Please Add Some Child Components for Layout SQV2!
			</div>;
  }
  const findChildByName = (name: string) => allowedChildren.find(e => e.props.block.component?.name === name) ?? null;
  const headerV2 = findChildByName('HeaderV2');
  const statusPill = findChildByName('StatusPill');
  const formContent = findChildByName('Form') || findChildByName('SingleForm');
  const bragBarV2 = findChildByName('BragBarV2');
  const calloutBox = findChildByName('CalloutBox');
  const filteredChildren = allowedChildren.filter(e => !CONTROLLED_COMPONENT_NAMES.includes(e.props.block.component?.name ?? ''));
  return <main id="base" className={cls(style.root, extendStyles)} data-sentry-component="LayoutSQV2" data-sentry-source-file="LayoutSQV2.tsx">
			{headerV2}
			{statusPill}
			<section className={style.content} data-testid="content">
				{formContent ? <div className={style.formSlot} data-testid="form-slot">
						{formContent}
					</div> : null}
				{bragBarV2}
				{calloutBox}
				{filteredChildren}
			</section>
		</main>;
}
export default withChildren(LayoutSQV2);